export const handleDynamicImportError = (error: unknown): void => {
  if (error instanceof Error && error.message.includes("dynamically imported module")) {
    window.location.reload();
  }
};

/**
 * Extracts detailed error message from API error response.
 * Handles nested error structures from Okta/backend API responses.
 *
 * @param error - The error object from RTK Query mutation
 * @returns The most specific error message available, or null if parsing fails
 *
 */

export const extractApiErrorDetails = (error: unknown): string | null => {
  try {
    if (error && typeof error === "object" && "data" in error) {
      const errorWithData = error as { data?: { errors?: Array<{ general?: string }> } };
      const generalError = errorWithData.data?.errors?.[0]?.general;

      if (generalError && typeof generalError === "string") {
        const jsonMatch = generalError.match(/\{.*\}$/s);
        if (jsonMatch) {
          try {
            const parsedError = JSON.parse(jsonMatch[0]);

            // Priority 1: Most specific error from errorCauses array
            if (parsedError.errorCauses?.[0]?.errorSummary) {
              return parsedError.errorCauses[0].errorSummary;
            }

            // Priority 2: General error summary
            if (parsedError.errorSummary) {
              return parsedError.errorSummary;
            }
          } catch (parseError) {
            console.warn("Failed to parse JSON in general error:", parseError);
          }
        }

        // Priority 3: Plain string in general field (no JSON structure)
        return generalError;
      }
    }
  } catch (e) {
    console.error("Failed to parse error message:", e);
  }
  return null;
};
